import React from 'react';
import { DashedTitle, DatePicker, Icon } from '@fasstech/middle-design-system';
import { dateTsToFr } from '@@viewHelpers/date.js';
import classNames from 'classnames';
import { getIsSelected } from '@@viewHelpers/getPropsGuarantees.js';
import GuaranteesDeathSelfEmployedCard from './GuaranteesDeathSelfEmployedCard.jsx';
import GuaranteesDisabilitySelfEmployedCard from './GuaranteesDisabilitySelfEmployedCard.jsx';
import Beneficiaries from '@@views/souscriptionRecap/client/components/Beneficiaries.jsx';

const SummarySelfEmployed = ({
  effectDate,
  getMiddleText,
  getMiddleBoolean,
  guarantees,
  PTIADeathGuarantees,
  spousePensionGuarantees,
  educationPensionGuarantees,
  disabilityGuarantees,
  invalidityGuarantees,
  customerCardOptions,
  granteesCardOptions,
  onEditBeneficiaries,
  grantees,
  isProjectEditable
}) => {
  return (
    <>
      <Beneficiaries
        getMiddleText={getMiddleText}
        grantees={grantees}
        customerCardOptions={customerCardOptions}
        granteesCardOptions={granteesCardOptions}
        onEdit={onEditBeneficiaries}
        isProjectEditable={isProjectEditable}
      />
      <div className="flex flex-col items-center gap-4">
        <Icon name={'circleUmbrella'} size={50} />
        <DashedTitle>Garanties</DashedTitle>
        <div className={'flex flex-col md:flex-row gap-4 w-full'}>
          <div className={'w-1/2'}>
            <DatePicker
              label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
              value={dateTsToFr(effectDate)}
              disabled={true}
            />
          </div>
          <div
            className={classNames('grow w-full', {
              hidden:
                getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_DECES_EST_NECESSAIRE'
                ) &&
                !getIsSelected('OPTION_TT_CAUSE', guarantees) &&
                !getIsSelected('OPTION_ACC', guarantees) &&
                !getIsSelected('OPTION_REDUC', guarantees) &&
                !getIsSelected('OPTION_RCONJ', guarantees)
            })}
          >
            {getMiddleBoolean(
              'NIVEAUXGARANTIESETTARIFS_GAR_DECES_EST_NECESSAIRE'
            ) &&
              (getIsSelected('OPTION_TT_CAUSE', guarantees) ||
                getIsSelected('OPTION_ACC', guarantees) ||
                getIsSelected('OPTION_REDUC', guarantees) ||
                getIsSelected('OPTION_RCONJ', guarantees)) && (
              <GuaranteesDeathSelfEmployedCard
                getMiddleText={getMiddleText}
                getMiddleBoolean={getMiddleBoolean}
                guarantees={guarantees}
                PTIADeathGuarantees={PTIADeathGuarantees}
                spousePensionGuarantees={spousePensionGuarantees}
                educationPensionGuarantees={educationPensionGuarantees}
              />
            )}
          </div>
          <div
            className={classNames('w-full', {
              hidden:
                !getIsSelected('OPTION_INCAP', guarantees) &&
                !getIsSelected('OPTION_INVAL', guarantees)
            })}
          >
            {(getIsSelected('OPTION_INCAP', guarantees) ||
              getIsSelected('OPTION_INVAL', guarantees)) && (
              <GuaranteesDisabilitySelfEmployedCard
                getMiddleText={getMiddleText}
                getMiddleBoolean={getMiddleBoolean}
                guarantees={guarantees}
                disabilityGuarantees={disabilityGuarantees}
                invalidityGuarantees={invalidityGuarantees}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SummarySelfEmployed;
